import React from 'react'
import Header from './Header';
import Footer from './Footer';

function Page404() {
  return (
    <div className='flex flex-col h-screen'>
        <Header />
        <div className='flex flex-auto'>
            <div className='mt-5 w-full'>
                <div className='flex flex-col items-center justify-center'>
                    <span><i style={{fontSize: '75px'}} className="material-icons-outlined text-[#ef4444]">error</i>&nbsp;</span>
                    <p className='m-0 px-5 text-justify lg:text-center justify-center text-2xl font-bold'>
                        Opps! La p&aacute;gina que buscas no fue encontrada.
                    </p>
                    <p className='text-sm px-5 text-justify lg:text-center'>
                        Al parecer hubo un error con la direcci&oacute;n que buscas 
                        o la p&aacute;gina ya no esta disponible.
                    </p>
                    <a className='mb-10' href="/"><img src="./assets/img/logoSistema2.png" alt="company logo" /></a>
                </div>
            </div>
        </div>
        <Footer />
    </div>
  )
}

export default Page404;